import service from "./request.js";

export default {
  // 获取敏感检测状态
  getSensitiveCheckStatus() {
    return service({
      method: "GET",
      url: "api/system/sensitive-check/status",
    }).then((res) => {
      return res.data;
    });
  },

  // 切换敏感检测开关
  toggleSensitiveCheck() {
    return service({
      method: "POST",
      url: "api/system/sensitive-check/toggle",
    }).then((res) => {
      return res.data;
    });
  },
};
